import { FieldValues, Path, AutocompleteElement } from "react-hook-form-mui"
import { useInfiniteSelectList } from "@/core/hooks"
import { infiniteListboxProps } from "@/core/components"
import { Userbot } from "../../interfaces"
import { useLazyRolesQuery } from "../../store"

interface IProps<T extends FieldValues> {
  name: Path<T>
  label?: string
  required?: boolean
  disabled?: boolean
}

/**
 * Селект роли. Цепочка/расписание таргетируются на роль по её ИМЕНИ,
 * поэтому в форму записывается `name` роли (строка).
 */
export const RoleSelect = <T extends FieldValues>({
  name,
  label = "Роль",
  required,
  disabled,
}: IProps<T>) => {
  const [lazyRoles] = useLazyRolesQuery()
  const list = useInfiniteSelectList<Userbot.Role>({
    fetchPage: (p) => lazyRoles(p).unwrap(),
    getId: (r) => r.name,
  })

  return (
    <AutocompleteElement<T>
      name={name}
      label={label}
      loading={list.isFetching}
      required={required}
      options={list.items.map((r) => r.name)}
      autocompleteProps={{
        disabled,
        fullWidth: true,
        filterOptions: (o) => o,
        onInputChange: (_, v, reason) => {
          if (reason === "input") list.setSearch(v)
        },
        noOptionsText:
          list.error != null
            ? "Не удалось загрузить список"
            : list.items.length === 0
              ? "Ничего не найдено"
              : "Ещё...",
        ...infiniteListboxProps({
          hasMore: list.hasMore,
          isFetching: list.isFetching,
          onLoadMore: list.loadMore,
        }),
        renderOption: (props, option: string, state) =>
          [props, option, state] as React.ReactNode,
      }}
    />
  )
}
